//import { TopContentButton } from "../TopContentButton";

export function TopContentAdmVeiculo(props) {
  return (
    <>     
      <span className="title-content-veiculo">{`${props.veiculo} - ${props.placa}`}</span>     
    </>
  );
}
